import { snowplowAppIds, snowplowInitializer } from "@comparaonline/event-tracker";

import { useAppContext } from "../../../lib/appContext";
import { getAppEnv } from "../../../utils/env";
import { AppEnv } from "../../../utils/env/constants";
import { formStepRenderEvent, sendFormSubmitEvent } from "./events";
import { sendEvent, useSendEvent } from "./sendEvent";

const getTrackerEnv = () => {
  const currentEnv = getAppEnv();
  return currentEnv === AppEnv.PRODUCTION ? AppEnv.PRODUCTION : AppEnv.DEVELOPMENT;
};

export const initEventTracker = (countryCode: string) => {
  snowplowInitializer.initializeSnowplow();
  snowplowInitializer.initializeTracker(snowplowAppIds.appIds[countryCode], getTrackerEnv());
};

export const useFormEventTracker = () => {
  const {
    countryCode,
    businessUnitConfig: { businessCode }
  } = useAppContext();
  const businessUnit = businessCode;
  const eventData = {
    businessUnit,
    countryCode
  };

  return {
    formStepRenderEvent: formStepRenderEvent(eventData),
    sendFormSubmitEvent: sendFormSubmitEvent(eventData)
  };
};

export { sendEvent, useSendEvent };
